import { connect } from "react-redux";
import SearchResultsQueryContainer from "./searchResults-query-container";
import { searchActions } from "core/state/redux/data/search";

const SearchResultsReduxContainer = (props) => {
  let {
    search,
    closeSearch,
    mobileonclick,
    changeSearch,
    setDisplaySearch,
    token,
    setSearchVal,
  } = props;

  if (typeof search === "undefined" || search.length < 2 || search === null)
    return <></>;

  return (
    <SearchResultsQueryContainer
      token={token}
      search={search}
      closeSearch={closeSearch}
      mobileonclick={mobileonclick}
      changeSearch={changeSearch}
      setDisplaySearch={setDisplaySearch}
      setSearchVal={setSearchVal}
    />
  );
};

const mapStateToProps = (state) => ({
  search: state.search.search,
  allCategories: state.queries.data,
  allCategoriesTmp: state.queries.temp,
  token:
    typeof state.customer !== "undefined" &&
    typeof state.customer.data !== "undefined" &&
    typeof state.customer.data !== "undefined" &&
    typeof state.customer.data.token !== "undefined"
      ? state.customer.data.token
      : false,
});

const mapDispatchToProps = (dispatch) => {
  return {
    closeSearch: () => {
      dispatch(searchActions.toggleSearch(false));
    },
    changeSearch: (searchTerm) => {
      dispatch(searchActions.changeSearch(searchTerm));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultsReduxContainer);
